import { skipColum } from "./columnNames";

/*
// Example of a worksheet payload

{
  "PartitionKey": "MBK",
  "RowKey": "7897bc4e-e658-350f-d2ed-79b8242df931",
  "Timestamp": "2018-09-14T23:12:58.7546873Z",
  "CreatedBy": "undefined",
  "CreatedByDisplayName": "Saikumar",
  "CreatedDate": "2018-09-13T16:11:12.734Z",
  "DeptName": "Levis MENS",
  "DeptNo": 600,
  "LastModifiedBy": "undefined",
  "LastModifiedByDisplayName": "undefined",
  "LastModifiedDate": "2018-09-14T23:12:58.611Z",
  "OpDiv": "MBK",
  "RequestHeaderId": "7897bc4e-e658-350f-d2ed-79b8242df931",
  "RequestHeaderName": "SampleToday",
  "Status": "In Progress",
  "VendorName": "Levis /AM",
  "VendorNo": 400,
  "Products": [
    {
      "PartitionKey": "7897bc4e-e658-350f-d2ed-79b8242df931",
      "RowKey": "127e6038-2470-f387-42ed-9dce307c1cd1",
      "Timestamp": "2018-09-13T16:11:12.8168675Z",
      "DeptNo": 551,
      "DeptName": "MICHAEL KORS MENS",
      "VendorNo": 331,
      "VendorName": "MICHAEL KORS/AM",
      "VendorPid": "testpid-0002",
      "VendorPidDesc": "testpid",
      "MbksPid": "testpid-0002-mbk",
      "MbksPidDesc": "testpid-mbk",
      "MbksClass": 300,
      "MbksClassName": "cls-mbk",
      "MbksSubClass": 400,
      "MbksSubClassName": "scls-mbk",
      "Cost": 10,
      "TicketRetail": 18,
      "CompareAt": "abc-mbk",
      "CompareAtSource": "cde-mbk",
      "AndUp": "xyz-mbk",
      "Source": "Test-LL-mbk",
      "Season": "test",
      "MultiOf": 1,
      "TicketType": "test-mbk",
      "MasterStyleDiv": 100,
      "MasterStyle": 500,
      "MasterStyleName": "mst-mbk",
      "NrfColor": 101,
      "NrfColorName": "Grey-mbk",
      "NrfSize": 300,
      "NrfSizeName": "Medium",
      "MbksStyleSeq": 2,
      "MbksMarkStyleNo": 1090,
      "MbksMarkStyleName": "msn-mbk",
      "VendorUpc": "vendorupc-mbk",
      "CorpInHouseUpc": "cihupc-mbk",
      "Quanity": 200,
      "RequestHeaderId": "7897bc4e-e658-350f-d2ed-79b8242df931",
      "ProductId": "127e6038-2470-f387-42ed-9dce307c1cd1",
      "CreatedBy": "undefined",
      "CreatedByDisplayName": "Saikumar",
      "CreatedDate": "2018-09-13T16:11:12.734Z",
      "Status": "InProgress",
      "OpDiv": "MBK",
      "LastModifiedBy": "undefined",
      "LastModifiedByDisplayName": "Saikumar",
      "LastModifiedDate": "2018-09-13T16:11:12.734Z"
    }
  ]
}

// Product Rows

//   "DeptNo": 551,
//   "DeptName": "MICHAEL KORS MENS",
//   "VendorNo": 331,
//   "VendorName": "MICHAEL KORS/AM",
//   "VendorPid": "testpid-0002",
//   "VendorPidDesc": "testpid",
//   "MbksPid": "testpid-0002-mbk",
//   "MbksPidDesc": "testpid-mbk",
//   "MbksClass": 300,
//   "MbksClassName": "cls-mbk",
//   "MbksSubClass": 400,
//   "MbksSubClassName": "scls-mbk",
//   "Cost": 10,
//   "TicketRetail": 18,
//   "CompareAt": "abc-mbk",
//   "CompareAtSource": "cde-mbk",
//   "AndUp": "xyz-mbk",
//   "Source": "Test-LL-mbk",
//   "Season": "test",
//   "MultiOf": 1,
//   "TicketType": "test-mbk",
//   "MasterStyleDiv": 100,
//   "MasterStyle": 500,
//   "MasterStyleName": "mst-mbk",
//   "NrfColor": 101,
//   "NrfColorName": "Grey-mbk",
//   "NrfSize": 300,
//   "NrfSizeName": "Medium",
//   "MbksStyleSeq": 2,
//   "MbksMarkStyleNo": 1090,
//   "MbksMarkStyleName": "msn-mbk",
//   "VendorUpc": "vendorupc-mbk",
//   "CorpInHouseUpc": "cihupc-mbk",
//   "Quanity": 200,

*/

export function createMapping(from, to) {
  return { from, to };
}

export function createWorkSheetFromExcelRows(excelRows, mappings = []) {
  if (!excelRows) {
    return;
  }

  const columnNames = excelRows[0];
  const mappedColumnNames = applyColumnMapings(columnNames, mappings);

  const products = excelRows.slice(1).map((row, i) => {
    return mappedColumnNames.reduce(
      (acc, name, idx) => {
        return name ? { ...acc, [name]: row[idx] } : acc;
      },
      { ImportRowNo: i }
    );
  });

   const finalProducts = products.map((product) => {
    return { ...product, InitialQuantity: product.Quantity };
  });
  return {
    Products: finalProducts,
  };
}

function applyColumnMapings(columnNames, temp_mappings) {
  const mappings = [...temp_mappings, { from: "QTY", to: "InitialQuantity" }];
  return columnNames.reduce((acc, name) => {
    const mappedColumnName = mappings.find((m) => m.from === name);
    let item;
    if (mappedColumnName) {
      if (mappedColumnName.to !== skipColum.value) {
        item = mappedColumnName.to;
      }
    }
    return [...acc, item];
  }, []);
}

export function getColumnHeadersFromWorksheet(excelRows) {
  let candidate = excelRows[0];
  return candidate && candidate.length ? candidate : [];
}

export function findMappingByColumn(column, mappings) {
  let mapping = mappings.find((m) => m.from === column);
  return mapping ? mapping.to : skipColum.value;
}



// WEBPACK FOOTER //
// ./utilities/worksheet.js